export const createPermissionApi = (permissions = []) => {
  const normalized =
    permissions?.map((p) => p?.name?.toLowerCase()?.trim())?.filter(Boolean) ||
    [];

  const check = (perm) => normalized.includes(perm.toLowerCase().trim());

  const hasAny = (list = []) => list.some(check);
  const hasAll = (list = []) => list.every(check);

  return { check, hasAny, hasAll };
};
